// `start` and `end` are RFC 3339 strings; an empty `busy` array means the user's
// primary calendar is fully free over the window.
export interface BusyInterval {
  start: string;
  end: string;
}

export interface FreebusyPayload {
  type: "freebusy";
  busy: BusyInterval[];
  timeMin: string;
  timeMax: string;
}

const isString = (v: unknown): v is string => typeof v === "string";

const isBusyInterval = (v: unknown): v is BusyInterval => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.start) && isString(r.end);
};

export const parseFreebusyPayload = (v: unknown): FreebusyPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "freebusy") return null;
  if (!Array.isArray(r.busy)) return null;
  if (!r.busy.every(isBusyInterval)) return null;
  if (!isString(r.timeMin)) return null;
  if (!isString(r.timeMax)) return null;
  return {
    type: "freebusy",
    busy: r.busy,
    timeMin: r.timeMin,
    timeMax: r.timeMax,
  };
};
